export const createBooleanCell = (accessorPath: string) => {
  return {
    component: "Switch" as const,
    generateProps: (
      row: Record<string, unknown>,
      _index: number,
      _originalRow?: Record<string, unknown>,
    ) => ({
      id: accessorPath,
      isChecked: Boolean(
        row && typeof row === "object" ? row[accessorPath] : undefined,
      ),
    }),
  };
};
